import * as Vue from "vue";
import * as mutations from "../../mutation-types"

export const processDictionaryEntry = (store, item) => {
    store.commit(mutations.ADD_OR_UPDATE_DICTIONARY_ENTRY, item)
}

export const createDictionaryEntry = (store, item) => {
    return axios.post(`/api/dictionaries`, item)
        .then(res => {
            processDictionaryEntry(store, res.data.data)
            return res
        })
}

export const updateDictionaryEntry = (store, item) => {
    return axios.patch(`/api/dictionaries/${item.id}`, item)
        .then(res => {
            processDictionaryEntry(store, res.data.data)
            return res
        })
}

export const createOrUpdateDictionaryEntry = (store, item) => {
    return item.id ?
        updateDictionaryEntry(store, item) :
        createDictionaryEntry(store, item)
}

export const removeDictionaryEntry = (store, item) => {
    return axios.delete(`/api/dictionaries/${item.id}`)
        .then(res => {
            store.commit(mutations.REMOVE_DICTIONARY_ENTRY, item)
            return res
        })
}
